import type { MembershipsV1BillingCycle, MembershipsV1Currency } from '@sdk/Api'

interface BillingCycle {
	CURRENCY_USD: string
	CURRENCY_EUR: string
}

interface Plan {
	BILLING_CYCLE_MONTHLY: BillingCycle
	BILLING_CYCLE_ANNUAL: BillingCycle
}

export interface PricingData {
	revenueCapTopInterval: number
	PLAN_ID_STARTER: Plan
	PLAN_ID_BUSINESS: Plan
}

export function getPriceData(
	monthlyRevenue: number,
	pricingTable: PricingData[],
	membershipPlanId: string,
) {
	return pricingTable.find(
		(pricingData) =>
			monthlyRevenue <= pricingData.revenueCapTopInterval && pricingData[membershipPlanId],
	)
}

export function getMonthlyPriceByRevenue(
	monthlyRevenue: number,
	pricingTable: PricingData[],
	membershipPlanId: string,
	currency: MembershipsV1Currency,
	billingCycle: MembershipsV1BillingCycle,
) {
	const pricingData = getPriceData(monthlyRevenue, pricingTable, membershipPlanId)?.[
		membershipPlanId
	]

	return pricingData
		? pricingData[billingCycle]
			? pricingData[billingCycle][currency]
			: null
		: null
}
